import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuth, signInWithEmailAndPassword, createUserWithEmailAndPassword, signInWithPopup, GoogleAuthProvider } from 'firebase/auth';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import FirestoreService from '../assets/js/firestore_instance';
import AuthCheck from './AuthCheck';

const SignIn = () => {
  const navigate = useNavigate();

  const handleGoogleSignIn = async () => {
    const auth = getAuth();
    const googleAuthProvider = new GoogleAuthProvider();
    const db = FirestoreService.getFirestore();

    try {
      const result = await signInWithPopup(auth, googleAuthProvider);
      const user = result.user;
      const userDocRef = doc(db, "admin_users", user.uid);
      const docSnap = await getDoc(userDocRef);

      if (docSnap.exists()) {
        console.log("User already exists, updating data");
        await setDoc(userDocRef, {
          displayName: user.displayName,
          email: user.email,
          photoURL: user.photoURL
        }, { merge: true });
      } else {
        console.log("User doesn't exist, creating new document");
        await setDoc(userDocRef, {
          displayName: user.displayName,
          email: user.email,
          photoURL: user.photoURL,
          organizationId: []
        });
      }
      navigate('/dashboard');
    } catch (error) {
      console.error("Google sign-in error:", error);
    }
  };

  const handleSignIn = async (event) => {
    event.preventDefault();
    const email = document.getElementById("signin-email").value;
    const password = document.getElementById("signin-password").value;
    const auth = getAuth();

    try {
      await FirestoreService.initialize();
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      console.log("Signed in user: ", user);
      navigate('/dashboard');
    } catch (error) {
      alert("Sign in error: ", error);
    }
  };

  const handleSignUp = async (event) => {
    event.preventDefault();
    const email = document.getElementById("signup-email").value;
    const password = document.getElementById("signup-password").value;
    const name = document.getElementById("signup-name").value;
    const auth = getAuth();

    try {
      await FirestoreService.initialize();
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      await user.updateProfile({ displayName: name });
      const db = FirestoreService.getFirestore();
      const userDocRef = doc(db, "admin_users", user.uid);
      const docSnap = await getDoc(userDocRef);

      if (docSnap.exists()) {
        console.log("User already exists, signing in!");
        navigate('/dashboard');
      } else {
        console.log("User doesn't exist, creating new document");
        await setDoc(userDocRef, {
          displayName: name,
          email: user.email,
          photoURL: user.photoURL,
          organizationId: []
        });
        navigate('/dashboard');
      }
    } catch (error) {
      alert("Sign up error: " + error);
    }
  };

  const handlePanelSwitch = (event) => {
    const container = document.getElementById('container-form');
    if (event.target.id === 'signUp') {
      container.classList.add("right-panel-active");
    } else {
      container.classList.remove("right-panel-active");
    }
  };

  return (
    <>
    <AuthCheck navigateTo="dashboard" />
    <div className="sign-in-form-container">
      <div className="container-form" id="container-form">
        <div className="form-container sign-up-container">
          <div className="form_dup">
            <h1 className="form text-4xl pb-3">Create Account</h1>
            <span className="form">or use your email for registration</span>
            <input className="form" type="text" id="signup-name" placeholder="Name" required />
            <input className="form" type="email" id="signup-email" placeholder="Email" required />
            <input className="form" type="password" id="signup-password" placeholder="Password" required />
            <button className="form" style={{ marginTop: '10px' }} onClick={handleSignUp}>Sign Up</button>
          </div>
        </div>
        <div className="form-container sign-in-container">
          <div className="form_dup">
            <h1 className="form text-4xl">Sign in</h1>
            <div className="social-container">
              <button className="google form" type="button" onClick={handleGoogleSignIn}>Sign in with Google</button>
            </div>
            <span className="form">or use your account</span>
            <input className="form" type="email" id="signin-email" placeholder="Email" required />
            <input className="form" type="password" id="signin-password" placeholder="Password" required />
            <a className="form" href="#">Forgot your password?</a>
            <button className="form" onClick={handleSignIn}>Sign In</button>
          </div>
        </div>
        <div className="overlay-container">
          <div className="overlay">
            <div className="overlay-panel overlay-left">
              <h1 className="form text-4xl">Welcome Back!</h1>
              <p className="form white">To keep connected with us please login with your personal info</p>
              <button className="ghost form" id="signIn" onClick={handlePanelSwitch}>Sign In</button>
            </div>
            <div className="overlay-panel overlay-right">
              <h1 className="form text-4xl">Welcome to JoltChat!</h1>
              <p className="form white">Create an account and start your journey with us</p>
              <button className="ghost form" id="signUp" onClick={handlePanelSwitch}>Sign Up</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
  );
};

export default SignIn;